<p>details-payment-processors works!</p>
